import React from 'react';
import {
  IconButton,
  IconButtonProps,
  SxProps,
  Theme,
  Tooltip,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export interface ButtonCloseProps {
  onClick: IconButtonProps['onClick'];
  disabled?: boolean;
  size?: IconButtonProps['size'];
  ariaLabel?: string;
  tooltipTitle?: string;
  sx?: SxProps<Theme>;
  dataTestId?: string;
  dataCy?: string;
}

const ButtonClose: React.FC<ButtonCloseProps> = ({
  onClick,
  disabled = false,
  size = 'small',
  ariaLabel = 'Close dialog',
  tooltipTitle = 'Close',
  sx,
  dataTestId,
  dataCy,
}) => {
  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton
          variant="outlined"
          onClick={onClick}
          disabled={disabled}
          size={size}
          aria-label={ariaLabel}
          data-testid={dataTestId}
          data-cy={dataCy}
          sx={sx}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ButtonClose;
